import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Col, Row, Card, Dropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import { loadChatMetricsDataRequest, loadUserMetricsDataRequest } from "../redux/Actions";
import { ResponsiveContainer,ComposedChart, Bar, BarChart, AreaChart, Area, LineChart, Line, CartesianGrid, Legend, XAxis, YAxis, Tooltip, Cell } from 'recharts';

const MetricsGroup = () => {
  const [dateRange, setDateRange] = useState(30);
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let location = useLocation();
 
  let {chatmetrics,user} = useSelector((state) => state.chatgroup);
  console.log("Data", chatmetrics);


  useEffect(() => {
    dispatch(loadChatMetricsDataRequest({ dateRange }));
  }, [dateRange, dispatch]);

  const handleDateRangeChange = (range) => {
    setDateRange(range); // Update the date range state
  };

  const getDateRangeText = () => {
    switch (dateRange) {
      case 7:
        return "Last 7 Days";
      case 30:
        return "Last 30 Days";
      case 90:
        return "Last 90 Days";
      default:
        return "Select Date Range";
    }
  };

  let columns = [
    {
      display_name: "chatId",
      field: "id",
      type: "number",
      hide: true,
      headerClass: "custom-header", 
      flex: 1,
    },
    {
      display_name: "Group Name",
      field: "channel_name",
      type: "text",
      headerClass: "custom-header", 
      flex: 1,
    },
    {
      display_name: "Message Count",
      field: "total_messages",
      type: "number",
      headerClass: "custom-header", 
      flex: 1,
    },
  ];

  const peakActivity = chatmetrics?.dateWiseMetrics?.length
  ? chatmetrics.dateWiseMetrics.reduce((max, current) =>
      current?.totalMessages > max?.totalMessages ? current : max
    )
  : { date: "N/A", totalMessages: 0 }; // Fallback value if dateWiseMetrics is undefined or empty

  return (
    <>
      <div>
        <Row>
          <Card>
            <Card.Body>
              <div className="text-end mb-3">
                <Dropdown>
                  <Dropdown.Toggle className="default-btn-color pt-1 pb-1 btn btn-primary" id="dropdown-basic">
                    {getDateRangeText()} {/* Show selected range */}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleDateRangeChange(7)}>Last 7 Days</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDateRangeChange(30)}>Last 30 Days</Dropdown.Item>
                    <Dropdown.Item onClick={() => handleDateRangeChange(90)}>Last 90 Days</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              
              <Row className="gy-1 dashboard">

                <Col xs={12} md={6} lg={3}>
                  <StatTile text="Total Channels" number={chatmetrics.totalChannels} color="#0c84a6" icon="fas fa-project-diagram" />
                </Col>

                <Col xs={12} md={6} lg={3}>
                  <StatTile text="Total Messages" number={chatmetrics.totalMessages} color="#f7c860" icon="fas fa-comment-dots" />
                </Col>

                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text="Active Automation Channels"
                    number={chatmetrics.activeAutomationChannels?.length}
                    color="#9dd766"
                    icon="fas fa-chart-line"
                  />
                </Col>

                <Col xs={12} md={6} lg={3}>
                  <StatTile
                    text="In Active Automation Channels"
                    number={chatmetrics.neverUsedAutomationChannels?.length}
                    //number={`${peakActivity.date} (${peakActivity.totalMessages} messages)`}
                    color="#c9472f"
                    icon="fas fa-arrow-down"
                  />
                </Col>

              </Row>
              <Row className="gy-3 my-1 dashboard">
              <Col xs={12} lg={6} className='align-self-stretch'>
                  <Card style={{ height: '100%', border: 0, borderLeft: `3px solid #5C5CAD`, boxShadow: "-2px 2px 5px #0002" }}>
                    <Card.Body> <p className='card-title'>
                      Top 10 Active Groups
                    </p> 
                      <div id="myGrid"
                        style={{  marginTop: "10px", height: `370px`,width: "100%",}}
                        className="ag-theme-alpine"
                      >
                        <AgGridReact
                          rowData={chatmetrics.topChannelsByMessages} 
                          columnDefs={columns} 
                          defaultColDef={{
                            sortable: true,
                            filter: true,
                            resizable: true,
                          }}
                          suppressHorizontalScroll={true} 
                          rowClassRules={{
                            "dash-odd-row": (params) => params.node.rowIndex % 2 === 0, 
                            "dash-even-row": (params) => params.node.rowIndex % 2 !== 0, 
                          }}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} lg={6}>
                  <Card style={{ border: 0, borderLeft: `3px solid #5C5CAD`, boxShadow: "-2px 2px 5px #0002" }}>
                    <Card.Body>
                      <div className="card-title">
                        <span>Automation vs Manual</span>
                      </div>
                      <div style={{ height: '380px' }}>
                      <ResponsiveContainer width="100%" height={380}>
                          <BarChart
                            data={[
                              { name: "Automation", totalChannels: chatmetrics?.groupTypeMetrics?.Automation?.totalChannels, totalMessages: chatmetrics?.groupTypeMetrics?.Automation?.totalMessages },
                              { name: "Manual", totalChannels: chatmetrics?.groupTypeMetrics?.Manual?.totalChannels, totalMessages: chatmetrics?.groupTypeMetrics?.Manual?.totalMessages },
                            ]}
                          >
                            <XAxis dataKey="name" />
                            <YAxis yAxisId="left" orientation="left" />
                            <YAxis yAxisId="right" orientation="right" />
                            <Tooltip />
                            <Legend />
                            <Bar yAxisId="left" dataKey="totalChannels" fill="#8884d8" name="Total Channels" />
                            <Bar yAxisId="right" dataKey="totalMessages" fill="#82ca9d" name="Total Messages" />
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </Card.Body>
                  </Card>
                </Col> 
              </Row> 
              <Row className="gy-3 my-1 dashboard">
                <Col xs={12} lg={12}>
                  <Card style={{ border: 0, boxShadow: "-2px 2px 5px #0002" }}>
                    <Card.Body>
                      <div className="card-title">
                        <span>Daily Activity</span>
                      </div>
                      <div style={{ height: '360px' }}>
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={chatmetrics.dateWiseMetrics}>
                              <XAxis dataKey="date" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Line 
                                type="monotone" 
                                dataKey="totalChannels" 
                                stroke="#0a7674" 
                                name="Total Channels" 
                                dot={{ fill: "#0a7674", r: 4 }} // Custom dot color and size
                                strokeWidth={3}
                              />
                              <Line 
                                type="monotone" 
                                dataKey="totalMessages" 
                                stroke="var(--color-primary-orange)" 
                                name="Total Messages" 
                                dot={{ fill: "var(--color-primary-orange)", r: 4 }}
                                strokeWidth={3}
                              />
                            </LineChart>
                          </ResponsiveContainer>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default MetricsGroup;

function StatTile({ number, color, onClick, text, icon }) {
  return (
    <Card
      className="statCard clickable"
      style={{ borderLeft: `3px solid ${color}` }}
      onClick={onClick}
    >
      <Card.Body>
        <div className="d-flex align-items-center">
          <div>
            <p className="mb-0 text-secondary statTile-txt" style={{  }} >{text}</p>
            <h4 className="my-1" style={{ color: color }}>
              {number}
            </h4>
          </div>
          <div
            className="widgets-icons-2 rounded-circle text-white ms-auto"
            style={{
              background: `linear-gradient(45deg, ${color}, 80%, #f28f3420), 100%`,
            }}
          >
            <i className={icon}></i>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
